(ns frontend.view.nev.surveys.form.event
  (:require [ajax.core :as ajax]
            [frontend.events :as frontend-events]
            [frontend.view.nev.surveys.form.events :as events]
            [frontend.view.nev.surveys.form.sub :as sub]
            [potpuri.core :as potpuri]
            [re-frame.core :as rf]
            [ui.enrich.event :as enrich-event]
            [ui.enrich.model :as enrich-model]
            [ui.view.survey.sub :as survey-view-sub]))

(rf/reg-event-fx
 ::exit-editor
 (fn [{db :db} [_]]
   ;; Leaving with AI answers unsaved discards them, and so their job.
   {:fx [[:dispatch [::enrich-event/survey-settled (get-in db [::sub/survey-process :db/id])]]
         [:dispatch [::cleanup]]
         [:dispatch
          [::frontend-events/navigate
           {:path-args [:entity.type/survey-profile :id (get-in db [::sub/survey-profile :db/id])]}]]]}))


(rf/reg-event-fx
 ::cleanup
 (fn [{db :db} [_]]))

(rf/reg-event-fx
 ::submit-ok
 (fn [{db :db} [_ survey-id _resp]]
   (let [survey-profile-id (get-in db [::sub/survey-profile :db/id])]
     {:db (potpuri/dissoc-in db [::survey-view-sub/submitting? survey-id])
      :fx [[:dispatch [::events/load-editor-process survey-id survey-profile-id]]]})))

(rf/reg-event-fx
 ::submit-failed
 (fn [{db :db} [_ survey-id err]]
   (js/console.log "Submit failed : " survey-id " > " err)
   {:db (potpuri/dissoc-in db [::survey-view-sub/submitting? survey-id])}))

(rf/reg-event-fx
 ::submit
 (fn [{db :db} [_ survey-id submit?]]
   (let [process (get-in db [::sub/survey-process])
         from-status (:survey-process/status process)
         to-status (case from-status
                     :survey-process.status/draft :survey-process.status/prefilled
                     :survey-process.status/prefilled nil
                     :survey-process.status/wip :survey-process.status/submitted
                     :survey-process.status/submitted :survey-process.status/approved
                     :survey-process.status/approved :survey-process.status/approved-modified)]
     (when to-status
       {:db         (assoc-in db [::survey-view-sub/submitting? survey-id] true)
        :http-xhrio {:method          :post
                     :uri             "/surveys/api/complete-step"
                     :params          {:process-id  survey-id
                                       :from-status from-status
                                       :to-status   to-status}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::submit-ok survey-id]
                     :on-failure      [::submit-failed survey-id]}}))))

(defn answers-left-unsaved
  "The unsaved answers ({series {question-id answer}}) a successful save of
   `sent` leaves: those entered or applied after the save started, which it
   did not carry."
  [current sent]
  (->> current
       (keep (fn [[series answers]]
               (let [left (into {}
                                (remove (fn [[question-id answer]]
                                          (and (contains? (get sent series) question-id)
                                               (= answer (get-in sent [series question-id])))))
                                answers)]
                 (when (seq left) [series left]))))
       (into {})))

(defn save-ok
  "The answers `unsaved-answers` are saved. `applied-job` is the AI job whose
   answers were in the editor when the save started."
  [{db :db} [_ survey-id unsaved-answers submit? applied-job resp]]
  (let [saved-answers (->> resp
                           :body
                           (seq))
        updated-answer-series (->> saved-answers
                                   ;; Use answer-set-index, fall back to answer-timeseries, default to 0
                                   ;; This matches how backend groups answers and how frontend reads them
                                   (group-by #(or (:survey-answer/answer-set-index %)
                                                  (:survey-answer/answer-timeseries %)
                                                  0))
                                   (map (fn [[idx series-answers]]
                                          [idx (->> series-answers
                                                    (map (fn [a]
                                                           [(->> a :survey-answer/question)
                                                            (->> a
                                                                 :survey-answer/answer)]))
                                                    (into {}))]))
                                   (into {}))
        db (-> db
               (assoc-in [::survey-view-sub/saved-answer-series survey-id] updated-answer-series)
               (update-in [::survey-view-sub/unsaved-answer-series survey-id]
                          answers-left-unsaved unsaved-answers)
               (potpuri/dissoc-in [::survey-view-sub/saving? survey-id]))
        left? (seq (get-in db [::survey-view-sub/unsaved-answer-series survey-id]))]
    {:db db
     ;; The AI answers applied when the save started are saved now, so their
     ;; job is done. A submit waits until the answers that came during the
     ;; save are saved too.
     :fx (cond-> [[:dispatch [::enrich-event/survey-saved survey-id applied-job]]]
           (and submit? left?)       (conj [:dispatch [::save survey-id true]])
           (and submit? (not left?)) (conj [:dispatch [::submit survey-id]]))}))

(rf/reg-event-fx ::save-ok save-ok)

(rf/reg-event-fx
 ::save-failed
 (fn [{db :db} [_ survey-id err]]
   {:db (potpuri/dissoc-in db [::survey-view-sub/saving? survey-id])}))

(rf/reg-event-fx
 ::save
 (fn [{db :db} [_ survey-id submit?]]
   (let [unsaved-answers (get-in db [::survey-view-sub/unsaved-answer-series survey-id] {})]
     {:db         (assoc-in db [::survey-view-sub/saving? survey-id] true)
      :http-xhrio {:method          :post
                   :uri             "/surveys/api/save-response-series"
                   :params          {:process-id     survey-id
                                     :series-updates unsaved-answers}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::save-ok survey-id unsaved-answers submit?
                                     (enrich-model/survey-applied-job db survey-id)]
                   :on-failure      [::save-failed survey-id]}})))
